// extracted by css-extract-rspack-plugin
export default {"cls1":"SidebarAddComment-cls1_799","cls2":"SidebarAddComment-cls2_BRj SidebarAddComment-cls1_799"};